import { render, staticRenderFns } from "./waringmessage.vue?vue&type=template&id=1ec7c0f2&"
import script from "./waringmessage.vue?vue&type=script&lang=ts&"
export * from "./waringmessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "waringmessage.vue"
export default component.exports